import { render } from "./myProfileContent.vue?vue&type=template&id=8531725c&scoped=true"
import script from "./myProfileContent.vue?vue&type=script&lang=js"
export * from "./myProfileContent.vue?vue&type=script&lang=js"

import "./myProfileContent.vue?vue&type=style&index=0&id=8531725c&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8531725c"]])

export default __exports__